import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HomePage from "../../Home";
import {
  Container,
  Grid,
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography
} from "@material-ui/core";
import TComisiones from "../TComisiones";
import TResumen from "../TResumen";
import GComision from "../GComision"
import PollIcon from '@material-ui/icons/Poll'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import MoneyOffIcon from '@material-ui/icons/MoneyOff'
import { obtenerComisiones }
  from "../../../ducks/cotizacionDuck";
import BackDrop from "./../../../global/BackDrop"

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const VComisiones = () => {
  const dispatch = useDispatch();
  const comisionables = useSelector(store => store.cotizacion.comisionables);
  const noComisionables = useSelector(store => store.cotizacion.noComisionables);
  const resumenAgente = useSelector(store => store.cotizacion.resumenAgente);
  const [isLoad, setIsLoad] = useState(false);
  const [value, setValue] = useState(0);

  useEffect(() => {
    setIsLoad(true);
    dispatch(obtenerComisiones()).then((Reposne) => {
      setIsLoad(false);
    });
  }, [dispatch])

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <HomePage>
      <Container>
        <Grid container>
          <Grid item xs={12} style={{margin: "15px 0"}}>
            <AppBar position="static" color="secondary">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="on"
                indicatorColor="primary"
                aria-label="scrollable force tabs example"
              >
                <Tab
                  label="Ventas por Mes"
                  icon={<MonetizationOnIcon />}
                  {...a11yProps(0)}
                />
                <Tab
                  label="Ventas por mes NO Comisionables"
                  icon={<MoneyOffIcon />}
                  {...a11yProps(1)}
                />
                <Tab
                  label="Resumen"
                  icon={<PollIcon />}
                  {...a11yProps(2)}
                />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <TComisiones
                rows={comisionables}
                isPago={false}
                isReporte={false}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <TComisiones
                rows={noComisionables}
                isPago={false}
                isReporte={false}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <GComision />
                <TResumen
                  tituloTabla={'Resumen Agente'}
                  resumen={resumenAgente}
                />
              </div>
            </TabPanel>
          </Grid>
        </Grid>
        <BackDrop open={isLoad} />
      </Container>
    </HomePage>
  );
}
export default VComisiones